import WarningIconSvg from "PFIcons/warning.svg";

const WarningIcon = (props) => <WarningIconSvg viewBox="2 2 16 16" {...props} />;

export default WarningIcon;
